import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Page } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ViewsAside } from '@shapeable/ui';

const cls = classNames('page-conversations-aside-layout');

// -------- Types -------->

// -------- Props -------->

export type PageConversationsAsideLayoutProps = Classable & HasChildren & { 
  entity?: Page;
};

export const PageConversationsAsideLayoutDefaultProps: Omit<PageConversationsAsideLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const ViewStyles = breakpoints({
  base: css`
    .shp--slice-layout-content-links-aside {
      u {
        color: ${theme.COLOR('link')};
      }
    }
  `,
});



// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    View: styled(ViewsAside)`${ViewStyles}`,
};

export const PageConversationsAsideLayout: Shapeable.FC<PageConversationsAsideLayoutProps> = (props) => {
  const { className, children, entity, } = props;
  
  return (
    <My.Container className={cls.name(className)}>
      <My.View entity={entity} />
    </My.Container>
  )
};

PageConversationsAsideLayout.cls = cls;